import HelloComponent from './component';

$e.components.register( new HelloComponent() );
